import { render, staticRenderFns } from "./Caso.vue?vue&type=template&id=68cda1c0&scoped=true&"
import script from "./Caso.vue?vue&type=script&lang=js&"
export * from "./Caso.vue?vue&type=script&lang=js&"
import style0 from "./Caso.vue?vue&type=style&index=0&id=68cda1c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cda1c0",
  null
  
)

export default component.exports